import type { QueryClient } from "@tanstack/react-query";
import type { PaginatedResultOfGetTeacherResponse } from "@/openapi/generated/models";
import { TeachersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

const DEFAULT_TENANT_ID = resolveEffectiveTenantNumber();

export function seedPublicTeachersQuery(
  queryClient: QueryClient,
  data: PaginatedResultOfGetTeacherResponse,
  page: number = 1,
  pageSize: number = 1000,
  active: boolean = true,
) {
  queryClient.setQueryData(
    [QueryKeys.Teachers, DEFAULT_TENANT_ID, "public", page, pageSize, active],
    data,
  );
}

export async function prefetchTeachersGetPublic(
  queryClient: QueryClient,
  page: number = 1,
  pageSize: number = 1000,
  active: boolean = true,
) {
  const service = new TeachersApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Teachers, DEFAULT_TENANT_ID, "public", page, pageSize, active],
    queryFn: () =>
      service.apiTeachersScrollGet({
        page,
        pageSize,
        active,
        xTenantID: DEFAULT_TENANT_ID,
      }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
